export const GraphColors = [
  '#d0315e',
  '#9c3552',
  '#692336',
  '#633843',
  '#856970',
  '#611e2f',
];
export const GraphGrayColors = ['#696969', '#aaaaaa', '#e3e3e3', '#e6e6e6'];
export const GraphOptions = {
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: function (context) {
          return context.parsed.y.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          });
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
          });
        },
      },
    },
  },
};
